module.exports = __webpack_public_path__ + "img/PR.561e97d7.svg";